import React, { useState, useEffect } from 'react'
import Spinner from 'components/common/Spinner'
import { connect } from 'react-redux';


// reactstrap components
import {
  Button,
  Card,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip, CardBody,
} from "reactstrap";


import { getCalculateFiled, postCalculateFiled } from "actions/uploadFile";

const ReportList = ({ Reports, setReport, deleteReport, setActive }) => {
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <>
            <h2 className="h4 title">
              <small>Lista sprawozdań</small>
            </h2>
            <Table striped>
              <thead className='smallerFont'>
                <tr>
                  <th>Nazwa Pliku</th>
                  {/*<th></th>
                  <th></th>*/}
                  <th>Data od</th>
                  <th>Data do</th>
                  <th className="text-right">Opcje</th>
                </tr>
              </thead>
              <tbody>
                {Reports && Reports.map((fileItem, idx) => {
                  return (
                    <tr key={fileItem.id}>
                      <td>{fileItem.file}</td>
                      {/*<td></td>
                      <td></td>*/}
                      <td>{fileItem.data_od}</td>
                      <td>{fileItem.data_do}</td>
                      {/* actions */}
                      <td className="td-actions text-right">
                        <Button
                          className="btn-link mr-1"
                          color="success"
                          data-toggle="tooltip"
                          id={"tooltip-Dane" + idx}
                          onClick={(e) => { setReport(fileItem.id) }}
                          size="sm"
                          type="button"
                        >
                          <i className="fas fa-edit"></i>
                        </Button>
                        <Button
                          className="btn-link "
                          color="danger"
                          data-toggle="tooltip"
                          id={`editM`}
                          size="sm"
                          type="button"
                          onClick={e => { setActive(fileItem.id); deleteReport(true) }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </Button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </>
        </CardBody>
      </Card>
    </Col>
  )
}

const mapStateToProps = (state) => ({
  UploadFile: state.UploadFile,
});

export default connect(mapStateToProps, null)(ReportList)
